module.exports = __webpack_public_path__ + "static/media/qm.94764fd7.svg";